// extracted by mini-css-extract-plugin
export var headingPaddingStyle = "sticky_side_nav_wrapper-module--headingPaddingStyle--uY4Db";
export var menuStickyWrapperStyle = "sticky_side_nav_wrapper-module--menuStickyWrapperStyle--Gjcge";
export var menuWrapperStyle = "sticky_side_nav_wrapper-module--menuWrapperStyle--a6uMF";